var map = {
	"./Footer/CompanyInformation.tsx": 59314,
	"./Footer/CopyRight.tsx": 14904,
	"./GlobalNotificationBar/GlobalNotificationBar.tsx": 67734,
	"./Header/HeaderClickable.tsx": 17432
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46943;